const EXPIRATION_TIME_KEY = 'rp-expiration-time';
const CODE_KEY = 'rp-code';
const CODE_TYPE = 'rp-type';


export function saveExpirationTime(value) {
  const data = localStorage.getItem(EXPIRATION_TIME_KEY);
  let newData;

  if (!data) {
    newData = [value];
  } else {
    newData = JSON.parse(data);

    newData = newData.filter(item => item.login !== value.login);
    newData.push(value);
  }

  localStorage.setItem(EXPIRATION_TIME_KEY, JSON.stringify(newData));
}

export function getLast() {
  const data = localStorage.getItem(EXPIRATION_TIME_KEY);

  if (!data) {
    return null;
  }

  const formattedData = JSON.parse(data);

  return formattedData[formattedData.length - 1];
}

export function getLastByLogin(login) {
  const data = localStorage.getItem(EXPIRATION_TIME_KEY);

  if (!data) {
    return null;
  }

  return JSON.parse(data)
    .reverse()
    .find(item => item.login === login);
}

export function getExpirationSeconds(time) {
  const timeDiff = Math.trunc((new Date(time) - new Date()) / 1000);

  return timeDiff < 0 ? 0 : timeDiff;
}

export function addMinutesToDate(date, minutes) {
  return new Date(date.getTime() + minutes * 60000);
}

export function getCodeExpirationDate(expTime) {
  return addMinutesToDate(new Date(), expTime);
}

export function saveCode(value) {
  localStorage.setItem(CODE_KEY, JSON.stringify(value));
}

export function saveType(type) {
  localStorage.setItem(CODE_TYPE, JSON.stringify(type));
}

export function getCode() {
  return JSON.parse(localStorage.getItem(CODE_KEY));
}

export function getType() {
  return JSON.parse(localStorage.getItem(CODE_TYPE));
}

export function getDataToRestore() {
  return JSON.parse(localStorage.getItem(CODE_KEY));
}

export function clearCode() {
  localStorage.removeItem(CODE_KEY);
}

export function clearData() {
  localStorage.removeItem(EXPIRATION_TIME_KEY);
  localStorage.removeItem(CODE_KEY);
  localStorage.removeItem(CODE_TYPE);
}

export function clearCodeIfExpired() {
  const data = JSON.parse(localStorage.getItem(CODE_KEY));

  if (!data) {
    return;
  }

  if (!getExpirationSeconds(data.expires)) {
    localStorage.removeItem(CODE_KEY);
    localStorage.removeItem(CODE_TYPE);
  }
}
